import React from 'react';
import { MailIcon } from 'lucide-react';
export function ContactSection() {
  return <section className="py-12 px-5" data-id="element-70">
      <div className="max-w-lg mx-auto text-center" data-id="element-71">
        <div className="glass rounded-xl p-8" data-id="element-72">
          <MailIcon className="w-8 h-8 text-teal mx-auto mb-4" data-id="element-73" />
          <h3 className="text-lg font-bold text-white mb-2" data-id="element-74">
            ¿Tienes alguna duda?
          </h3>
          <p className="text-white/60 text-sm mb-5 leading-relaxed" data-id="element-75">
            Escríbenos y te respondemos en menos de 24 horas.
          </p>
          <a href="mailto:electronicecomjj@gmail.com" className="inline-block px-6 py-3 bg-accent text-white font-bold text-sm rounded-full hover:bg-accent-dark transition-colors" data-id="element-76">
            electronicecomjj@gmail.com
          </a>
        </div>
      </div>
    </section>;
}